import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import InputBox from "../../../../common/interactive/InputBox";
import TextareaBox from "../../../../common/interactive/TextareaBox";
import GlobalTooltip from "../../../../common/GlobalTooltip";
import { searchTabInCaseType } from "../../../../../lib/misc";

export default function SurgicalTab1({classes, activeCase, updateHandler, itemData, apiCase}) {
    return <div className={classes.drawer_pannel}>
        <h3 className={classes.pannel_title}>#1 Referral for Surgical Evaluation</h3>
        <div className={classes.drawer_row}>                
            {searchTabInCaseType(activeCase, "workers_comp") && 
            
            <div className='flex-container'>
                <CheckboxCell isDisabled={true} label={'Preauthorization Needed'} checked={true} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_1_preauthorization_required', type_id: itemData.id}}/>
                <GlobalTooltip noMargin={true}>
                    Preauthorization is always needed for WC cases
                </GlobalTooltip>
            </div>
            }
        </div>

        <div className={`${classes.drawer_flex_block} ${classes.drawer_flex_block_equal}`}>
            <div className='flex-container'>
                <InputBox label={'Consult Type'} action={updateHandler} currentValue={itemData.step_1_consult_type} identifier={{folder: 'surgeries', type: apiCase, field: 'step_1_consult_type', type_id: itemData.id}}/>
                <GlobalTooltip noMargin={true}>
                    Service Type from referral (NextGen referral order textDisplay)
                </GlobalTooltip>
            </div>
            <div className='flex-container'>
                <TextareaBox label={'Area'} height={'medium'} action={updateHandler} currentValue={itemData.step_1_area} identifier={{folder: 'surgeries', type: apiCase, field: 'step_1_area', type_id: itemData.id}}/>
                <GlobalTooltip noMargin={true}>
                    Comments from referral (NextGen referral order comments)
                </GlobalTooltip>
            </div>
        </div>
        
    </div>
}